import React from 'react';
import { DonutChart } from '../../../common/ReusableComponent/Chart';

const TicketsSoldChart = ({ activeBookSummary }) => {
  const ticketsSold = activeBookSummary?.total_tickets_sold || 0;
  const remainingTickets = activeBookSummary?.remaining_tickets || 0;

  const hasData = ticketsSold > 0 || remainingTickets > 0;

  const data = {
    labels: ['Tickets Sold', 'Remaining Tickets'],
    datasets: [
      {
        data: [ticketsSold, remainingTickets],
      },
    ],
  };

  return (
    <div
      style={{
        padding: '20px',
        background: '#FFFFFF',
        // border: '1px solid #EBEAF2',
        boxShadow: '0px 2px 8px rgba(6, 12, 34, 0.04)',
        borderRadius: '20px',
        width: '525px',
        height:"300px",
        marginTop: '15px',
        maxHeight: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {hasData ? (
        <DonutChart
          labels={data.labels}
          datasets={data.datasets}
          title="Tickets Sold This Month"
          legendPosition="right"
          theme="custom"
          noBorder
          height={"277px"}
          noShodow
     
        />
      ) : (
        <div
          style={{
            fontSize: '16px',
            color: '#999',
            textAlign: 'center',
            fontStyle: 'italic',
          }}
        >
          No data available for ticket sales.
        </div>
      )}
    </div>
  );
};

export default TicketsSoldChart;
